module.exports = __webpack_public_path__ + "static/media/RecomendaProclamaçãoRepublica.d7513d58.jpg";